import { a as e } from "./index864.mjs";
var o = e, s = function(a, r) {
  return new (o(a))(r === 0 ? 0 : r);
};
export {
  s as a
};
